import axios from 'axios';
import { LoginResponse, UserData } from '../types';
import { apiClient } from './apiClient';
import { ApiError } from '../error/error';




export const getUserData = async (): Promise<any | null> => {
  try {
    const response = await apiClient.get<UserData>('/api/admin/profile');
    console.log('getUserData: ', response);
    return response;

  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      // Throw an ApiError with message and status code from response
      throw new ApiError(error.response.data.message ||error.response.data.error || 'Failed to get profile current user', error.response.status);
    }
    throw new Error('An unknown error occurred');
  }
  
};
export const UpdateProfileUser = async ( data:any) => {
  try {
    const response = await apiClient.put(`api/admin/profile`, data );

    return response.data.message;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      // Throw an ApiError with message and status code from response
      throw new ApiError(error.response.data.message || 'Failed to update  profile current user', error.response.status);
    }
    throw new Error('An unknown error occurred');
  }
};